module.exports = __webpack_public_path__ + "img/duncan.31bd619b.jpeg";